import { useContext, useEffect } from "react";
import { PUCT_number } from "../config";
import useQuery from "../hooks/useQuery";
import { Cards, PlanCard, PlanTag, PlansSection } from "../styles/Plan.styled";
import { RootContext } from "../context/RootContext";

interface PlansProps {
  plans: any;
  address: any;
}

export const Plans = (props: PlansProps) => {
  const { providerData } = useContext<any>(RootContext);
  const query = useQuery();
  const origin = query.get("origin") || "";
  const { plans, address } = props;

  let moreUrl = "#";
  if (origin && origin.toLowerCase() === "lowerebill") {
    if (address?.city && address?.zipcode && address?.street) {
      // moreUrl = `https://www.lowerebill.com/electricity-rates/texas/${address.city}/${address.zipcode}/${encodeURIComponent(address.street)}`
      moreUrl = `https://www.lowerebill.com/electricity-rates/texas/${address.city}/${address.zipcode}/`
      if (providerData?.show_name) {
        const formattedName = providerData.show_name.toLowerCase().replace(/ /g, '-');
        // moreUrl = `https://www.lowerebill.com/electricity-rates/texas/${address.city}/${address.zipcode}/${encodeURIComponent(address.street)}/${formattedName}`
        moreUrl = `https://www.lowerebill.com/electricity-rates/texas/${address.city}/${address.zipcode}/${formattedName}`
      }
    } else {
      moreUrl = "https://www.lowerebill.com/";
    }
  }

  // let params :any;
  // if (address && Object.keys(address).length !== 0 && address.city && address.zipcode && address.street ) {
  //   params = `https://www.personalized.energy/electricity-rates/texas/${address.city.toLowerCase()}/${
  //     address.zipcode
  //   }/${address.street.toLowerCase()}`;
  // } else {
  //   params = `https://www.personalized.energy`;
  // }

  return (
    <PlansSection>
      <h5>Your Personalized Recommendations</h5>
      <Cards>
        {plans.map((item: any, idx: any) => {
          const {
            contract_term,
            plan_name,
            provider_id,
            base_rate,
            cancel_fee,
            cancel_fee_type,
            enroll_url,
            rate,
          } = item;

          return (
            <PlanCard key={idx}>
              {/* <PlanTag>Best Overall Plan</PlanTag> */}
              <img
                src={`https://www.powerlego.com/ApiGateway/v2/logo/provider/${provider_id}`}
                alt=""
              />
              <div className="plan-rate">{rate}¢</div>
              <label>{"Rate"}</label>
              <p className="plan-term">{contract_term} Months</p>

              {PUCT_number[provider_id] && (
                <i>PUCT# {PUCT_number[provider_id]}</i>
              )}
              <div className="plan-name">{plan_name}</div>
              <div className="plan-fee" style={{ fontSize: 13, color: "#999" }}>
                Cancellation Fee: {cancel_fee}
              </div>
              <div className="plan-fee-type">
                {cancel_fee_type === "PerMonth"
                  ? ` (${"Per Remaining Month"})`
                  : ""}
              </div>
              <button onClick={() => window.open(enroll_url)}>
                Check Availability
              </button>
            </PlanCard>
          );
        })}
        <button data-more-url={moreUrl} className="more-button" onClick={() => window.open(moreUrl)}>
          {"More >"}
        </button>
      </Cards>
    </PlansSection>
  );
};
